import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Stack } from 'react-bootstrap';
import SpinnerButton from '../../../components/Button/SpinnerButton';
import { auth } from '../../../firebase';
import { sendPasswordResetEmail } from "firebase/auth";

function PasswordForgotScreen() {
    const { t } = useTranslation();
    const [error, setError] = useState();
    const [isLoading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();
    const [success, setSuccess] = useState(false);

    const handlePasswordReset = async (event) => {
        setError();
        setSuccess(false);
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            setValidated(true);
            return
        }

        setLoading(true);
        const email = form.elements.inputEmail.value;

        try {
            await sendPasswordResetEmail(auth, email);
            setSuccess(true);
        } catch (err) {
            const errorCode = err.code;
            if (errorCode === 'auth/user-not-found') {
                setError(t('errors.userNotFound'));
            } else if (errorCode === 'auth/too-many-requests') {
                setError(t('errors.tooManyRequests'));
            } else {
                setError(t('errors.failedToSendEmail'));
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container className="py-5" style={{ maxWidth: '400px' }}>
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title">{t('password.forgot.title')}</h2>
                </Col>
            </Row>

            <Row>
                <Col xs={12}>
                    <Form noValidate validated={validated} onSubmit={handlePasswordReset}>
                        <Form.Group className="mb-4">
                            <Form.Label htmlFor="inputEmail">{t('password.forgot.email')}</Form.Label>
                            <Form.Control
                                required
                                id="inputEmail"
                                type="email"
                                placeholder={t('password.forgot.emailPlaceholder')}
                                disabled={isLoading}
                            />
                            <Form.Control.Feedback type="invalid">
                                {t('password.forgot.emailValid')}
                            </Form.Control.Feedback>
                        </Form.Group>
                        {error && <div className="text-danger mb-3">{error}</div>}
                        {success && <div className="text-success mb-3">{t('password.forgot.emailSent')}</div>}
                        <Stack gap={3}>
                            <SpinnerButton
                                type="submit"
                                disabled={isLoading || success}
                                className="w-100 bg-pink"
                                label={t('password.forgot.sendResetLink')}
                            />
                            <SpinnerButton
                                onClick={() => navigate('/login')}
                                className="w-100"
                                label={t('password.forgot.backToLogin')}
                            />
                        </Stack>

                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default PasswordForgotScreen;
